




import { Component, Prop, Vue } from 'vue-property-decorator';
import { routerModule } from '@/store';
import NotFound from '@/views/NotFound.vue';
import Page from '@/views/Page.vue';
import FeatureImage from '@/views/FeatureImage.vue';
import Contact from '@/views/Contact.vue';

@Component({
  components: {
    NotFound,
    Page,
    FeatureImage,
    Contact,
  },
})
export default class extends Vue {
  get component() {
    let currentRoute = this.$route.path;
    if (!currentRoute.endsWith('/')) {
      currentRoute = currentRoute + '/';
    }
    const routes = routerModule.routes.filter(
      route => route.path === currentRoute,
    );

    if (routes.length) {
      return routes[0].component;
    }
    return 'not-found';
  }
}
